import { render, staticRenderFns } from "./CustomerViewShippingAddresses.vue?vue&type=template&id=d3e7d81c&scoped=true"
import script from "./CustomerViewShippingAddresses.vue?vue&type=script&lang=js"
export * from "./CustomerViewShippingAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e7d81c",
  null
  
)

export default component.exports